<script lang="ts">
    import type {DocumentDetailReactivePageData, DocumentDetailStaticPageData} from 'src/features/record/kp-document-detail-page/types';
    import {getPageContext} from 'shared/layouts/page-context';
    import KpHeading from 'shared/components/kp-heading/KpHeading.svelte';
    import {ProjectFinancialOverview} from 'src/features/erp-sutor/features/project-financial-overview';

    const pageContext = getPageContext<DocumentDetailStaticPageData, DocumentDetailReactivePageData>();
    const projectRecord = pageContext.staticData.model.record;
</script>

<KpHeading type="h2">Hospodaření zakázky</KpHeading>
<ProjectFinancialOverview {projectRecord}/>